import React, { useEffect, useRef, useState } from "react";
import call from "./Images/call.png";
import mail from "./Images/mail.png";
import adddress from "./Images/address.png";
import insta from "./Images/insta.png";
import facebook from "./Images/facebook.png";
import linkdin from "./Images/linkdin.png";
import youtube from "./Images/youtube.png";
import logo from "../Pages/Home/Images/logo.png";
import { RiArrowDownSLine } from "react-icons/ri";
import { MdCall } from "react-icons/md";
import { FaInstagramSquare } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaSquareYoutube } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { MdCancel } from "react-icons/md";

const Header = () => {
  const [showRegister, setShowRegister] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const registerModalRef = useRef<HTMLDivElement>(null);
  const loginModalRef = useRef<HTMLDivElement>(null);

  // Handle outside click for Register Modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (registerModalRef.current && !registerModalRef.current.contains(event.target as Node)) {
        setShowRegister(false);
      }
    };

    if (showRegister) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showRegister]);

  // Handle outside click for Login Modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (loginModalRef.current && !loginModalRef.current.contains(event.target as Node)) {
        setShowLogin(false);
      }
    };

    if (showLogin) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showLogin]);

  const [submenu, setShowsubmenu] = useState(false);
  const [submenu2, setShowsubmenu2] = useState(false);
  const [activeMenu, setActiveMenu] = useState("Home");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div>
      <header>
        <div className="flex flex-wrap justify-center w-100 bg-[#A6E129] items-center px-[8%] py-3">
          <div className="flex flex-wrap md:w-4/5 sm:w-[100%] items-center text-[#212529] text-base font-normal gap-x-8 gap-y-2">
            <li
              className="flex items-center cursor-pointer"
              onClick={() => (window.location.href = `tel:${9509933959}`)}
            >
              <MdCall className="text-xl" />
              +91 9509933959
            </li>
            <li
              className="flex items-center cursor-pointer"
              onClick={() => (window.location.href = `mailto:info@ensolsolutions.com`)}
            >
              <IoMail />
              info@ensolsolutions.com
            </li>
          </div>
          <div className="flex md:w-1/5 sm:w-[100%] md:justify-end sm:justify-start w-[100%] mt-5 md:mt-0 justify-start">
            <FaInstagramSquare
              className="mx-2 cursor-pointer"
              onClick={() => window.location.href = "https://www.instagram.com/#/"}
            />
            <FaFacebookSquare
              className="mx-2 cursor-pointer"
              onClick={() => window.location.href = "https://www.facebook.com/#"}
            />
            <FaLinkedin
              className="mx-2 cursor-pointer"
              onClick={() => window.location.href = "#"}
            />
            <FaSquareYoutube
              className="mx-2 cursor-pointer"
              onClick={() => window.location.href = "https://www.youtube.com/channel/#"}
            />
          </div>
        </div>

        <div className="bg-[#ffffff] px-[8%] flex flex-wrap w-full justify-between">
          <div className="w-[24%] py-5">
            <a href="/">
              <img className="lg:w-[120px] object-contain cursor-pointer" src={logo} alt="Logo" />
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#101729]"
            >
              {/* Hamburger Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-8 h-8"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
          </div>

          <div className="hidden lg:flex items-center justify-between pl-5 w-[56%]">
            <nav className="w-full">
              <ul className="flex justify-between items-center h-full">
                {/* Menu Items */}
                {["Home", "Services", "Product", "Our Partners", "Blog", "About Us"].map(
                  (item, idx) => (
                    <li
                      key={idx}
                      className={`hover:border-b-[3px] hover:border-[#A6E129] active:border-b-[3px] active:hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer ${activeMenu === item ? "border-[#A6E129]" : ""}`}
                      onClick={() => {
                        setActiveMenu(item);
                        item === "About" && setShowsubmenu(!submenu);
                        item === "Directors" && setShowsubmenu2(!submenu2);
                      }}
                    >
                      {item === "About" || item === "Directors" ? (
                        <span className="flex items-center">
                          <a href="#" className="text-[#101729]">{item}</a>
                          <RiArrowDownSLine className="ml-2" />
                        </span>
                      ) : (
                        <a href={`/${item.toLowerCase()}`}>
                          {item === "Contact" ? "Contact Us" : item}
                        </a>
                      )}
                    </li>
                  )
                )}
              </ul>
              {submenu && (
                <ul className="lg:absolute bg-[#E1E8F0] flex flex-col h-[187px] w-[191px] z-50 justify-between items-center top-[15%] lg:left-[33%] left-[7%]">
                  <li className="hover:border-b-[3px] hover:border-[#FDBC12] active:border-b-[3px] active:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
                    <a href="/about">About RMB</a>
                  </li>
                  <li className="hover:border-b-[3px] hover:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
                    <a href="/rmbleaders">RMB Leaders</a>
                  </li>
                  <li className="hover:border-b-[3px] hover:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
                    <a href="/rmbjaipur">RMB Jaipur</a>
                  </li>
                </ul>
              )}
              {submenu2 && (
                <ul className="lg:absolute bg-[#E1E8F0] flex flex-col h-[100px] w-[191px] z-50 justify-around items-center top-[15%] lg:left-[58%] left-[7%]">
                  <li className="hover:border-b-[3px] hover:border-[#FDBC12] active:border-b-[3px] active:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
                    <a href="/leadership">Leadership Team</a>
                  </li>
                  <li className="hover:border-b-[3px] hover:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
                    <a href="#">Co-ordinator Team</a>
                  </li>
                </ul>
              )}
            </nav>
          </div>

          {/* Registration/Login Buttons */}
          <div className="hidden lg:flex pl-8 gap-x-4 w-[20%] py-5 justify-end items-center">
            <button
              className="bg-[#29AAE1] rounded-full w-[110px] h-14 text-[#F1F4F9] font-[16px]"
              onClick={() => {
                window.location.href = "/#contact";
              }}
            >
              Contact Us
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
  <div className="lg:hidden w-full bg-slate-950/85 fixed top-0 left-0 z-40 h-[100vh]"  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
    <div className="flex flex-col w-[75%] bg-[#A6E129] p-5 items-start h-[100vh] z-50">
      <nav className="w-full">
        <ul className="w-full">
          {["Home", "Services", "Product", "Our Partners", "Blog", "About Us"].map((item) => (
            <li
              key={item}
              className="py-2 cursor-pointer hover:bg-[#29AAE1] hover:text-white"
              onClick={() => setActiveMenu(item)}
            >
              <a href={`/${item.toLowerCase()}`}>{item}</a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  </div>
)}

        </div>
      </header>
    </div>
  );
};

export default Header;
